(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
window.onload = function () {
    const subcategories = {
        "Delivery and Store Collections": ["Where is my order?", "I have a click and collect query", "I have a tracking query", "Courier Experience", "I have a delivery enquiry"],
        "Returns and Refunds": ["Refund Issue", "How do I return an item?", "Difficulties returning item", "Can I exchange an item?"],
        "Order Support": ["My order is incorrect or missing an item", "My product is faulty", "Order amendment", "Cancellation"],
        "Product Support": ["Will this be back in stock?", "Size Query", "Product Care", "Chemical Query", "More info about this product", "MW Guarantee"],
        "Payment/Promos/Gift Cards": ["I have a payment issue", "Promotion query", "Gift card", "Admin", "Price Match", "Loyalty Scheme", "VAT Invoice"],
        "Technical": ["Account Help", "Trouble with Website", "Privacy"],
        "Store Query": ["Store Complaint", "Store Compliment", "Where is my local store?", "E-receipt"],
        "Other": []
    };
 
    let categoryDropdown = document.querySelector("#category-dropdown");
    let subcategoryDropdown = document.querySelector("#subcategory-dropdown");

 
    function updateSubcategories(selectedCategory) {
        console.log("🔄 Selected Category:", selectedCategory);
        subcategoryDropdown.innerHTML = '<option value="">Please select a subcategory</option>';
        subcategoryDropdown.disabled = true;
 
        if (subcategories[selectedCategory] && subcategories[selectedCategory].length > 0) {
            subcategoryDropdown.disabled = false;
            subcategories[selectedCategory].forEach(sub => {
                let option = document.createElement("option");
                option.value = sub;
                option.textContent = sub;
                subcategoryDropdown.appendChild(option);
            });
        } else {
            console.warn("⚠️ No subcategories found for:", selectedCategory);
        }
    }
    categoryDropdown.addEventListener("change", function () {
        updateSubcategories(this.value);
    });
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }
 
      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);
 
        this.disclosure.open = isLargeScreen || isConfirmNewsletter;
 
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }
 
    customElements.define('footer-menu', FooterMenu);
  });
 
  document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.footer-menu-toggle');
    const menuHeaders = document.querySelectorAll('.footer-menu-header');
   
    toggleButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation(); 
        toggleMenu(this);
      });
    });
   
    menuHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const toggleButton = this.querySelector('.footer-menu-toggle');
        toggleMenu(toggleButton);
      });
    });
   
    function toggleMenu(button) {
      const menuContent = button.closest('.footer-col').querySelector('.footer-menu__links');
      if (menuContent.classList.contains('active')) {
        menuContent.classList.remove('active');
        button.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
      } else {
        menuContent.classList.add('active');
        button.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
